import { render, staticRenderFns } from "./TableReport.vue?vue&type=template&id=0a0b445c&scoped=true"
import script from "./TableReport.vue?vue&type=script&lang=ts"
export * from "./TableReport.vue?vue&type=script&lang=ts"
import style0 from "./TableReport.vue?vue&type=style&index=0&id=0a0b445c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0b445c",
  null
  
)

export default component.exports